import React from 'react';
import Flagship from '../../core/flagship';
import {Link} from 'react-router';
import { Button, Feed, Loader, Segment, Icon } from 'semantic-ui-react';

class RecentFavorites extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();

    }

    // Separate component state for UI only
    getInitialState() {
        return {
            offset: 0,
            items: [],
            error: '',
            loading: false
        }
    }

    componentDidMount() {
        if (this.props.userId !== 0) {
            this.getFeedItems(this.props.userId);
        }
    }

    componentWillUnmount() {
        this.interval = null;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props && nextProps.userId !== 0) {
            this.getFeedItems(nextProps.userId);
        }
    }


    getFeedItems(userId) {
        this.setState({
            loading:true
        });

        let self = this;

        if (typeof userId === "undefined") {
            userId = this.props.userId;
        }

        Flagship.get(
            'search/any/',
            {
                search: '',
                onlyFavorites: userId,
                combine: false,
                limit:8
            },
            function(response) {
                if (response.data.success === true ) {
                    self.setState(
                        {
                            items:  response.data.results,
                            loading: false

                        });
                } else {
                    self.setState(
                        {
                            error: "Failed to load recent activity.",
                            loading: false
                        }
                    );
                }
            }
        );

    }


    getMessage(action) {
        if ( Flagship.config.possibleActions.hasOwnProperty(action) ) {
            return Flagship.config.possibleActions[action]
        }
        return '';
    }

    getRecordLink(name, key, type) {
        let icon = 'exclamation';
        switch (type) {
            case 'client':
                icon = 'briefcase';
                break;
            case 'rfp':
                icon = 'dollar';
                break;
            case 'io':
                icon = 'rocket';
                break;
            case 'line_item':
                icon = 'pin';
                break;
            case 'io_product':
                icon = 'pin';
                break;
        }

        if ( type === "rfp" || type === "io" ) {
            name = '#' + key + ' - ' + name;
        }
        return (
            <h3>
                <Icon className="feed-icon" disabled size="large" color="grey" name={icon} />
                {name}
            </h3>
        );
    }


    render() {
        let getRecordLink = this.getRecordLink;
        return (
            <div className="fade-in">
                <Feed>
                    {this.state.error !== '' ? this.state.error : ''}

                    {typeof this.state.items !== "undefined" && this.state.items.length > 0 ? this.state.items.map(function(item, i) {

                       return (
                           <Feed.Event key={"feed-item-" + i}>
                               <Feed.Content>
                                   <Feed.Extra text>
                                       <Link className="single-dash-widget-record" to={'/' + item.record_type + '/view/' + item.record_key}>
                                       <Segment>
                                         {getRecordLink(item.record_name, item.record_key, item.record_type)}
                                         <Icon name="star" className="favorite" />
                                         <em>In your favorites</em>
                                       </Segment>
                                       </Link>
                                   </Feed.Extra>
                               </Feed.Content>
                           </Feed.Event>
                       )
                    }) : <div><span className="white-text">No favorites found. Go add some and come back!</span></div>}
                </Feed>
                <Link to="/user/favorites">
                    <Button className="view-all-button" icon="caret right" content="View all favorites" />
                 </Link>

                <span>&nbsp;</span>&nbsp;
                {this.state.loading === true ? <Loader className="flagship-loader" active={this.state.loading} inline /> : null }
            </div>
        );
    }
}
export default RecentFavorites;





// WEBPACK FOOTER //
// ./src/components/dashboard/RecentFavorites.js